import clsx from 'clsx';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

type Variant = 'flat' | 'elevated' | 'outlined';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
  children: ReactNode;
}

const variants: Record<Variant, string> = {
  flat: 'bg-bg-raised border border-border-subtle',
  elevated:
    'bg-[var(--color-bg-elevated)] border border-border-subtle ' +
    'shadow-[var(--shadow-3)]',
  outlined: 'bg-transparent border border-border-subtle',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { variant = 'flat', className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      {...rest}
      className={clsx('rounded-[var(--radius-lg)]', variants[variant], className)}
    >
      {children}
    </div>
  );
});
